<template>
  <div>
    <table class="tableDetail" border="1"  v-for="item in data" :key="item.id">
      <tr>
        <th class="theadDetail">性能指标</th>
        <td class="tdDetail">{{item.performanceIndex ? item.performanceIndex : '无'}}</td>
      </tr>
      <tr>
        <th class="theadDetail">主要应用</th>
        <td class="tdDetail">{{item.chiefApplication ? item.chiefApplication : '无'}}</td>
      </tr>
      <tr>
        <th class="theadDetail">样品要求</th>
        <td class="tdDetail">{{item.sampleRequest ? item.sampleRequest : '无'}}</td>
      </tr>
      <tr>
        <th class="theadDetail">仪器说明</th>
        <td class="tdDetail">{{item.instrumentsThat ? item.instrumentsThat : '无'}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  name: 'DayiDetail',
  data () {
    return {
      data: [],
    }
  },
  created () {
    this.onloadDetail()
  },
  methods: {
    onloadDetail () {
      let parameter = {
        assetCode: this.$route.query.code,
        pageNum: 1,
        pageSize: 1,
      }
      http('/reservation/openTheInstrument','POST',parameter).then(res => {
        if(res.success) {
          let data = res.data.resultList
          this.data = data
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.tableDetail {      
  border-color: #D9D9D9;
  border-style: none;
}
.theadDetail {
  width: 155px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #666;
  background: #FAFAFA;
}
.tdDetail { 
  width: 937px;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  padding: 14px 15px;
  text-align: left;
}
</style>